import { Post } from '../helpers';
import { CsvColumnMapping } from '@/micros/edit-project/grid-areas/main/audiences/components/listsv2/csv-column-mapper-modal';
import { WorkingPasscodeList } from '@/types/passcode-list.types';

export default function UploadList({
  channel,
  projectUuid,
  body,
  signal,
}: {
  channel: number;
  projectUuid: string;
  body: { workingPasscodeList: WorkingPasscodeList; columnMapping: CsvColumnMapping[] };
  signal?: AbortSignal;
}) {
  return Post<{ message: string }>({
    url: `/v4/admin/attendees/${channel}/${projectUuid}/upload-lists`,
    body,
    signal,
  });
}
